/* @flow */
import Button from 'components/Button.jsx';
import Columns from 'components/Columns.jsx';
import Image from 'components/Image.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

import './styles/MarketingContent.scss';

class MarketingContent extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    onSignupButtonClick: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className="MarketingContent">
        <div className="MarketingContent-lead">
          <div className="MarketingContent-lead-quote">
            <div className="MarketingContent-lead-quote-open">“</div>
            <div className="MarketingContent-lead-quote-content">
              Remind gives me a sense of ease because I know what’s going on with my child on a
              daily basis.
              <div className="MarketingContent-lead-quote-attribution">
                <div className="MarketingContent-lead-quote-attribution-photo">
                  <Image src={require('assets/images/kamelia_reilly.png')} />
                </div>
                <div className="MarketingContent-lead-quote-attribution-content">
                  <div className="MarketingContent-lead-quote-attribution-content-name">
                    Kamelia Reilly
                  </div>
                  <div className="MarketingContent-lead-quote-attribution-content-role">
                    Kindergarten Parent
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="MarketingContent-lead-video">
            <iframe
              src="https://www.youtube.com/embed/Nav0GpNqorU"
              allowFullScreen
              frameBorder="0"
              title="Remind Teach Small video on YouTube"
              className="MarketingContent-lead-video-frame"
            />
          </div>
        </div>

        <h3 className="MarketingContent-subText">What is Remind?</h3>

        <h2 className="MarketingContent-copy">
          Remind is a free, safe, and easy-to-use communication tool that helps teachers reach
          students and parents where they are.
        </h2>

        <Button
          className="MarketingContent-signUpButton"
          onClick={this.props.onSignupButtonClick}
          eventElementName="MarketingContent-signUpButton">
          Sign up
        </Button>
        <Columns>
          <div>
            <h4 className="MarketingContent-columnHeader">
              15 seconds
              <div className="MarketingContent-columnBody">to sign up</div>
            </h4>
          </div>
          <div>
            <h4 className="MarketingContent-columnHeader">
              29 million
              <div className="MarketingContent-columnBody">students and parents use Remind</div>
            </h4>
          </div>
          <div>
            <h4 className="MarketingContent-columnHeader">
              3 out of 4 school districts
              <div className="MarketingContent-columnBody">in the U.S. use Remind</div>
            </h4>
          </div>
        </Columns>
      </div>
    );
  }
}
export default MarketingContent;
